import { render, staticRenderFns } from "./FPotensIKawasanKriteriaKih.vue?vue&type=template&id=455089ac&scoped=true"
import script from "./FPotensIKawasanKriteriaKih.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanKriteriaKih.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455089ac",
  null
  
)

export default component.exports